var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h1',[_vm._v("Mon compte")]),_c('router-link',{attrs:{"to":"/users"}},[_vm._v("Liste des comptes")]),_c('div',[_c('pre',[_vm._v(_vm._s(_vm.$store.state.auth.user))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }